import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../features/data-connector/redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ParentContentCard from '../common/ParentContentCard';
import CustomLoader from '../common/CustomLoader';
import { checkDataSourcePermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';
export class SalesForceCollectionsList extends Component {
  static propTypes = {
    dataConnector: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  async componentDidMount() {
    const { match, actions } = this.props;
    const { externalDbUuid, projectId, version } = match.params;
    await actions.loadExternalDatabaseForSalesforce({ projectId, externalDbUuid, version });
  }
  handleContinueButtonClick = () => {
    const { match, actions, history } = this.props;
    const { externalDbUuid, projectId, version } = match.params;
    history.push(
      `/2.0/data-connector/${version}/v/${projectId}/salesforce-datasource/${externalDbUuid}/create`,
    );
  };
  render() {
    const isAllowed = checkDataSourcePermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent>
          <PermissionDenied message="Data Source" />;
        </CommonPageComponent>
      );
    }

    const { externalDbSalesforce, loadExternalDatabaseForSalesforcePending } =
      this.props.dataConnector;
    if (loadExternalDatabaseForSalesforcePending) {
      return (
        <CommonPageComponent>
          <div className="text-center">
            <CustomLoader
              loading={loadExternalDatabaseForSalesforcePending}
              size="20px"
              color="#303453"
            />
          </div>
        </CommonPageComponent>
      );
    }
    const allColname = externalDbSalesforce ? externalDbSalesforce.completeData.tables : null;
    return allColname ? (
      <CommonPageComponent>
        <ParentContentCard title={' List of Collections via Salesforce'} icon={'collection'}>
          <div className="d-flex flex-wrap">
            {allColname.map((item, index) => (
              <span className={`card card--user-profile ml-4 card--collection-source`} key={index}>
                <div className="card-body">
                  <div className="avatar__meta">
                    <h5 className="avatar__title js-user-name" title={item.label}>
                      {item.label}
                    </h5>
                  </div>
                </div>
              </span>
            ))}
          </div>
          <div className="text-right">
            {allColname.length > 0 && (
              <button
                className="btn btn-theme-submit mt-3 float-right"
                onClick={this.handleContinueButtonClick}
              >
                <i className="wb webconnect-rocket"></i>
                &nbsp;Continue&nbsp;
              </button>
            )}
          </div>
        </ParentContentCard>
      </CommonPageComponent>
    ) : null;
  }
}

function mapStateToProps(state) {
  return {
    dataConnector: state.dataConnector,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SalesForceCollectionsList);
